import moment from 'moment'
import Periodicidad from '../../inumet_js_lib/model/tipos/periodicidad'
import { escalas } from './escalasGeoVisualizador'

const BALANCE_HIDRICO_CATEGORY = 'balanceHidrico'
const IPE_CATEGORY = 'ipe'
const BOLETINPLUVIO_CATEGORY = 'boletinPluvio'
const FWI_CATEGORY = 'fwi'
const NESTEROV_CATEGORY = 'nesterov'
const TEMPDIARIA_CATEGORY = 'tempdiaria'

let prodsCategories = [
    {
        id: 1,
        name: BALANCE_HIDRICO_CATEGORY,
        label: 'Balance Hidrico',
        active: true,
        linkDoc:
            'https://www.inumet.gub.uy/reportes/BalanceHidrico/MetodologiaBalanceHidricoINUMET.pdf',
    },
    {
        id: 2,
        name: BOLETINPLUVIO_CATEGORY,
        label: 'Mapas Pluviométricos',
        active: true,
        linkDoc:
            'https://www.inumet.gub.uy/clima/recursos-hidricos/boletin-pluviometrico',
    },
    {
        id: 3,
        name: IPE_CATEGORY,
        label: 'Índice de Precip. Estandarizado',
        active: true,
        linkDoc:
            'https://www.inumet.gub.uy/clima/recursos-hidricos/indice-de-precipitacion',
    },
    {
        id: 4,
        name: FWI_CATEGORY,
        label: 'Índices de Riesgo de Incendio',
        active: true,
        linkDoc:
            'https://www.inumet.gub.uy/reportes/pages/visualizadorFWI/pdf/Riesgo_incendio_02.pdf',
    },
    {
        id: 5,
        name: NESTEROV_CATEGORY,
        label: 'Nesterov',
        active: false,
    },
    {
        id: 6,
        name: TEMPDIARIA_CATEGORY,
        label: 'Temperaturas Extremas Diarias',
        active: true,
    },
]

let prodsDef = [
    {
        id: 1,
        categoryId: 1,
        category: BALANCE_HIDRICO_CATEGORY,
        name: 'bh_p',
        label: 'Precip. Acum. 10 dias (P)',
        fileName: 'YYYY_MM_DD_P_Decena.tif',
        fileNameTifWildcard: '*_P_Decena.tif',
        regexFecha: 'YYYY_MM_DD',
        folder: 'BalanceHidrico',
        escalaLabel: 'Precip mm',
        activo: true,
        archivoConfigPublicacion: 'bh.dat',
        periodicidad: Periodicidad.day10,
        escalaEnArchivo: false,
        diasFijosMes: [1, 11, 21],
        escala: escalas.escalaPrecip,
    },
    {
        id: 2,
        categoryId: 1,
        category: BALANCE_HIDRICO_CATEGORY,
        name: 'bh_etp',
        label: 'Evapotranspiración Potencial (ETP)',
        fileName: 'YYYY_MM_DD_ETP_Decena.tif',
        fileNameTifWildcard: '*_ETP_Decena.tif',
        regexFecha: 'YYYY_MM_DD',
        folder: 'BalanceHidrico',
        escalaLabel: 'ETP mm',
        activo: true,
        archivoConfigPublicacion: 'bh.dat',
        periodicidad: Periodicidad.day10,
        escalaEnArchivo: false,
        diasFijosMes: [1, 11, 21],
        escala: escalas.escalaETP,
    },
    {
        id: 3,
        category: BALANCE_HIDRICO_CATEGORY,
        categoryId: 1,
        name: 'bh_a',
        label: 'P - ETP (A)',
        fileName: 'YYYY_MM_DD_A_Decena.tif',
        fileNameTifWildcard: '*_A_Decena.tif',
        folder: 'BalanceHidrico',
        regexFecha: 'YYYY_MM_DD',
        escalaLabel: 'A mm',
        activo: true,
        archivoConfigPublicacion: 'bh.dat',
        periodicidad: Periodicidad.day10,
        escalaEnArchivo: false,
        diasFijosMes: [1, 11, 21],
        escala: escalas.escalaA,
    },
    {
        id: 4,
        categoryId: 1,
        category: BALANCE_HIDRICO_CATEGORY,
        label: 'Agua Disponible (AD)',
        name: 'bh_ad',
        fileName: 'YYYY_MM_DD_AD_Decena.tif',
        fileNameTifWildcard: '*_AD_Decena.tif',
        folder: 'BalanceHidrico',
        regexFecha: 'YYYY_MM_DD',
        escalaLabel: 'AD mm',
        activo: true,
        archivoConfigPublicacion: 'bh.dat',
        periodicidad: Periodicidad.day10,
        escalaEnArchivo: false,
        diasFijosMes: [1, 11, 21],
        escala: escalas.escalaAD,
    },
    {
        id: 5,
        categoryId: 1,
        category: BALANCE_HIDRICO_CATEGORY,
        name: 'bh_etr',
        label: 'Evapotranspitación Real (ETR)',
        fileName: 'YYYY_MM_DD_ETR_Decena.tif',
        fileNameTifWildcard: '*_ETR_Decena.tif',
        folder: 'BalanceHidrico',
        regexFecha: 'YYYY_MM_DD',
        escalaLabel: 'ETR mm',
        activo: true,
        archivoConfigPublicacion: 'bh.dat',
        periodicidad: Periodicidad.day10,
        escalaEnArchivo: false,
        diasFijosMes: [1, 11, 21],
        escala: escalas.escalaETP,
    },
    {
        id: 6,
        categoryId: 1,
        category: BALANCE_HIDRICO_CATEGORY,
        name: 'bh_vad',
        label: 'Variación Agua Disponible (VAD)',
        fileName: 'YYYY_MM_DD_VAD_Decena.tif',
        fileNameTifWildcard: '*_VAD_Decena.tif',
        folder: 'BalanceHidrico',
        regexFecha: 'YYYY_MM_DD',
        escalaLabel: 'VAD mm',
        activo: true,
        archivoConfigPublicacion: 'bh.dat',
        periodicidad: Periodicidad.day10,
        escalaEnArchivo: false,
        diasFijosMes: [1, 11, 21],
        escala: escalas.escalaA,
    },
    {
        id: 7,
        categoryId: 1,
        category: BALANCE_HIDRICO_CATEGORY,
        name: 'bh_def',
        label: 'Déficit Hídrico (Def)',
        fileName: 'YYYY_MM_DD_Def_Decena.tif',
        fileNameTifWildcard: '*_Def_Decena.tif',
        folder: 'BalanceHidrico',
        regexFecha: 'YYYY_MM_DD',
        escalaLabel: 'Def (mm)',
        activo: true,
        archivoConfigPublicacion: 'bh.dat',
        periodicidad: Periodicidad.day10,
        escalaEnArchivo: false,
        diasFijosMes: [1, 11, 21],
        escala: escalas.escalaETP,
    },
    {
        id: 8,
        categoryId: 1,
        category: BALANCE_HIDRICO_CATEGORY,
        name: 'bh_exc',
        label: 'Exceso Hídrico (Exc)',
        fileName: 'YYYY_MM_DD_Exc_Decena.tif',
        fileNameTifWildcard: '*_Exc_Decena.tif',
        folder: 'BalanceHidrico',
        regexFecha: 'YYYY_MM_DD',
        escalaLabel: 'Exc mm',
        activo: true,
        archivoConfigPublicacion: 'bh.dat',
        periodicidad: Periodicidad.day10,
        escalaEnArchivo: false,
        diasFijosMes: [1, 11, 21],
        escala: escalas.escalaExc,
    },
    {
        id: 9,
        categoryId: 1,
        category: BALANCE_HIDRICO_CATEGORY,
        name: 'bh_pad',
        label: 'Porcentaje de Agua Disponible (PAD)',
        fileName: 'YYYY_MM_DD_PAD_Decena.tif',
        fileNameTifWildcard: '*_PAD_Decena.tif',
        folder: 'BalanceHidrico',
        regexFecha: 'YYYY_MM_DD',
        escalaLabel: 'PAD %',
        activo: true,
        archivoConfigPublicacion: 'bh.dat',
        periodicidad: Periodicidad.day10,
        escalaEnArchivo: false,
        diasFijosMes: [1, 11, 21],
        escala: escalas.escalaPAD,
    },
    {
        id: 10,
        categoryId: 1,
        category: BALANCE_HIDRICO_CATEGORY,
        name: 'bh_ibh',
        label: 'Índice de Bienestar Hídrico (IBH)',
        fileName: 'YYYY_MM_DD_IBH_Decena.tif',
        fileNameTifWildcard: '*_IBH_Decena.tif',
        folder: 'BalanceHidrico',
        regexFecha: 'YYYY_MM_DD',
        escalaLabel: 'IBH',
        activo: true,
        archivoConfigPublicacion: 'bh.dat',
        periodicidad: Periodicidad.day10,
        escalaEnArchivo: false,
        diasFijosMes: [1, 11, 21],
        escala: escalas.escalaPAD,
    },
    {
        id: 11,
        categoryId: 2,
        category: BOLETINPLUVIO_CATEGORY,
        name: 'bp',
        label: 'Mapa Diario',
        fileName: 'R3_YYYY_MM_DD.tif',
        fileNameTifWildcard: '*.tif',
        folder: 'BoletinPluviometrico',
        regexFecha: 'YYYY_MM_DD',
        escalaLabel: 'Precip mm',
        activo: true,
        archivoConfigPublicacion: 'BoletinPluviometrico.mch',
        periodicidad: Periodicidad.day,
        diasFijosMes: null,
        escalaEnArchivo: false,
        escala: escalas.escalaPrecip,
    },
    {
        id: 12,
        categoryId: 3,
        category: IPE_CATEGORY,
        name: 'ipe_01',
        label: 'IPE 1 Mes',
        fileName: 'YYYY_MM_IPE_01meses.tif',
        fileNameTifWildcard: '*01meses.tif',
        folder: 'ipe',
        regexFecha: 'YYYY_MM',
        escalaLabel: '1 mes',
        activo: true,
        archivoConfigPublicacion: null,
        periodicidad: Periodicidad.month,
        diasFijosMes: null,
        escalaEnArchivo: false,
        escala: escalas.escalaIPE,
    },
    {
        id: 13,
        categoryId: 3,
        category: IPE_CATEGORY,
        name: 'ipe_03',
        label: 'IPE 3 Meses',
        fileName: 'YYYY_MM_IPE_03meses.tif',
        fileNameTifWildcard: '*03meses.tif',
        folder: 'ipe',
        regexFecha: 'YYYY_MM',
        escalaLabel: '3 meses',
        activo: true,
        archivoConfigPublicacion: null,
        periodicidad: Periodicidad.month,
        diasFijosMes: null,
        escalaEnArchivo: false,
        escala: escalas.escalaIPE,
    },
    {
        id: 14,
        categoryId: 3,
        category: IPE_CATEGORY,
        name: 'ipe_06',
        label: 'IPE 6 Meses',
        fileName: 'YYYY_MM_IPE_06meses.tif',
        fileNameTifWildcard: '*06meses.tif',
        folder: 'ipe',
        regexFecha: 'YYYY_MM',
        escalaLabel: '6 meses',
        activo: true,
        archivoConfigPublicacion: null,
        periodicidad: Periodicidad.month,
        diasFijosMes: null,
        escalaEnArchivo: false,
        escala: escalas.escalaIPE,
    },
    {
        id: 15,
        categoryId: 3,
        category: IPE_CATEGORY,
        name: 'ipe_12',
        label: 'IPE 12 Meses',
        fileName: 'YYYY_MM_IPE_12meses.tif',
        fileNameTifWildcard: '*12meses.tif',
        folder: 'ipe',
        regexFecha: 'YYYY_MM',
        escalaLabel: '12 meses',
        activo: true,
        archivoConfigPublicacion: null,
        periodicidad: Periodicidad.month,
        diasFijosMes: null,
        escalaEnArchivo: false,
        escala: escalas.escalaIPE,
    },
    {
        id: 16,
        categoryId: 4,
        category: FWI_CATEGORY,
        name: 'fwi',
        label: 'FWI',
        fileName: 'FWI_YYYY_MM_DD.tif',
        fileNameTifWildcard: '*.tif',
        folder: 'fwi',
        regexFecha: 'YYYY_MM_DD',
        escalaLabel: 'FWI',
        activo: true,
        archivoConfigPublicacion: 'fwi.mch',
        periodicidad: Periodicidad.day,
        diasFijosMes: null,
        escalaEnArchivo: false,
        escala: escalas.escalaFWI,
    },
    {
        id: 17,
        categoryId: 5,
        category: NESTEROV_CATEGORY,
        name: 'nesterov',
        label: 'Nesterov',
        fileName: 'FWI_YYYY_MM_DD.tif',
        fileNameTifWildcard: '*.tif',
        folder: 'fwi',
        regexFecha: 'YYYY_MM_DD',
        escalaLabel: 'FWI',
        activo: false,
        archivoConfigPublicacion: 'bh.dat',
        periodicidad: Periodicidad.day,
        diasFijosMes: [],
        escalaEnArchivo: false,
        escala: escalas.escalaPrecip,
    },
    {
        id: 18,
        categoryId: 6,
        category: TEMPDIARIA_CATEGORY,
        name: 'tempMinDiaria',
        label: 'Temp. Mín. Diaria',
        fileName: 'YYYY_MM_DD_TempAireMinDiaria_Diaria.tif',
        fileNameTifWildcard: '*.tif',
        folder: 'mapas/TempAireMinDiaria',
        regexFecha: 'YYYY_MM_DD',
        escalaLabel: '°C',
        activo: true,
        archivoConfigPublicacion: null,
        periodicidad: Periodicidad.day,
        diasFijosMes: null,
        escala: null,
        escalaEnArchivo: true,
        escalaAdaptada: true,
        archivoEscalaFijaWildcard: '*escalafija.json',
        archivoEscalaAdaptadaWildcard: '*escalaadaptada.json',
    },
    {
        id: 19,
        categoryId: 6,
        category: TEMPDIARIA_CATEGORY,
        name: 'tempMaxDiaria',
        label: 'Temp. Máx. Diaria',
        fileName: 'YYYY_MM_DD_TempAireMaxDiaria_Diaria.tif',
        fileNameTifWildcard: '*.tif',
        folder: 'mapas/TempAireMaxDiaria',
        regexFecha: 'YYYY_MM_DD',
        escalaLabel: '°C',
        activo: true,
        archivoConfigPublicacion: null,
        periodicidad: Periodicidad.day,
        diasFijosMes: null,
        escala: null,
        escalaEnArchivo: true,
        escalaAdaptada: true,
        archivoEscalaFijaWildcard: '*escalafija.json',
        archivoEscalaAdaptadaWildcard: '*escalaadaptada.json',
    },
]

const escalasTitulosBH = [
    'Precip mm',
    'ETP mm',
    'A mm',
    'AD mm',
    'ETR mm',
    'VAD mm',
    'Def mm',
    'Exc mm',
    'PAD %',
    'IBH',
]

const escalasTitulosBoletinPluvio = ['Precip mm']

const escalasTitulosIPE = ['1 mes', '3 meses', '6 meses', '12 meses']

const archivosTif = [
    '2024_08_11_P_Decena_.tif',
    '2024_08_11_ETP_Decena_.tif',
    '2024_08_11_A_Decena_.tif',
    '2024_08_11_AD_Decena_.tif',
    '2024_08_11_ETR_Decena_.tif',
    '2024_08_11_VAD_Decena_.tif',
    '2024_08_11_Def_Decena_.tif',
    '2024_08_11_Exc_Decena_.tif',
    '2024_08_11_PAD_Decena_.tif',
    '2024_08_11_IBH_Decena_.tif',
    '2024_07_IPE_01meses.tif',
    '2024_07_IPE_03meses.tif',
    '2024_07_IPE_06meses.tif',
    '2024_07_IPE_12meses.tif',
    'R3_2024_08_22.tif',
]

const capasTitulosBH = [
    'Precip. Acum. (P)',
    'Evapotranspiración Potencial (ETP)',
    'A (P - ETP)',
    'Agua Disponible (AD)',
    'Evapotranspiración Real (ETR)',
    'Variación de Agua Disponible (VAD)',
    'Déficit Hídrico',
    'Exceso Hídrico',
    'Porcentaje de Agua Disponible (PAD)',
    'Índice de Bienestar Hídrico (IBH)',
]

const capasTitulosIPE = [
    'IPE 1 mes',
    'IPE 3 meses',
    'IPE 6 mes',
    'IPE 12 meses',
]

const capasTitulosBoletinPluvio = ['Boletín 22 Agosto 2024']

const prodsDefActivos = prodsDef.filter((p) => p.activo)

const getDefMenuGeoVisualizador = function (handler) {
    let res = {}
    res.categories = []
    res.mapProdsIndex = {}
    let iMapProd = 0
    prodsCategories.forEach((categoryDef, index) => {
        if (categoryDef.active) {
            let cat = {
                name: categoryDef.name,
                label: categoryDef.label,
                value: index,
                menus: [],
            }

            prodsDefActivos.forEach((prodDef) => {
                if (prodDef.activo && prodDef.category === categoryDef.name) {
                    res.mapProdsIndex[prodDef.name] = iMapProd
                    iMapProd++
                    cat.menus.push({
                        value: prodDef.name,
                        handler,
                        name: prodDef.label,
                        label: prodDef.label,
                        title: prodDef.label,
                    })
                }
            })

            res.categories.push(cat)
        }
    })

    return res
}

let capasTitulos = capasTitulosBH
    .concat(capasTitulosIPE)
    .concat(capasTitulosBoletinPluvio)

let escalasTitulos = escalasTitulosBH
    .concat(escalasTitulosIPE)
    .concat(escalasTitulosBoletinPluvio)

//console.log(prodsDefActivos)

function extraerFechaDesdeArchivo(nombreArchivo, periodicidad) {
    let regexFecha = null
    if (periodicidad >= Periodicidad.day && periodicidad < Periodicidad.month)
        regexFecha = /(\d{4})_(\d{2})_(\d{2})/
    else if (periodicidad === Periodicidad.month) regexFecha = /(\d{4})_(\d{2})/
    else if (periodicidad === Periodicidad.year) regexFecha = /(\d{4})/

    const match = nombreArchivo.match(regexFecha)

    if (match) {
        const [, year, month, day] = match
        // Usamos el año y el mes para crear la fecha. Asumimos el primer día del mes si no hay día especificado.
        return moment(`${year}-${month}-${day}`, 'YYYY-MM-DD').format(
            'YYYY-MM-DD'
        )
    }

    // Si no se encuentra una fecha, retornamos null
    return null
}

export {
    getDefMenuGeoVisualizador,
    capasTitulos,
    archivosTif,
    escalasTitulos,
    prodsCategories,
    prodsDef,
    prodsDefActivos,
    extraerFechaDesdeArchivo,
}
